// Hide any legacy loader without relying on jQuery's removed .load() shorthand.
window.addEventListener('load', function () {
  document.querySelectorAll('.ttloader').forEach(function (loader) {
    loader.style.display = 'none';
  });
});

  $(document).ready(function() {
    $('.btn-group').not('#main-collection-filters .btn-group').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  }); 

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => {
      // Cosmoshop: custom controls inside the Filter & Sort drawer should not be treated as drawer close buttons.
      if (button.closest('[data-cosmoshop-sort-select]')) return;
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element, index) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', element.parentElement?.hasAttribute('open') ? 'true' : 'false');

      const controlledElement = element.nextElementSibling;
      if (!controlledElement) return;
      if (!controlledElement.id) {
        controlledElement.id = `MenuDrawerPanel-${index}-${Math.random().toString(36).slice(2, 8)}`;
      }
      element.setAttribute('aria-controls', controlledElement.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    // Cosmoshop: if Filter & Sort has a debounced change waiting, closing the drawer
    // commits it immediately rather than making the customer wait for the timer.
    const facetForm = this.querySelector('#FacetFiltersFormMobile');
    if (
      facetForm
      && window.FacetFiltersForm
      && window.FacetFiltersForm.pendingSubmitTimer
      && typeof window.FacetFiltersForm.flushScheduledFormRender === 'function'
    ) {
      window.FacetFiltersForm.flushScheduledFormRender(facetForm, event instanceof Event ? event : null);
    }

    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove('overflow-hidden-mobile');
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    if (!detailsElement) return;

    if (detailsElement === this.mainDetailsToggle) {
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      return;
    }

    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
    
    
    


/* Cosmoshop smart collection/search view switcher: column count and details are independent. */
(function () {
  var LEGACY_STORAGE_KEY = 'cosmoshopProductGridViewMode';
  var COLUMN_STORAGE_KEY = 'cosmoshopProductGridColumns';
  var DETAILS_STORAGE_KEY = 'cosmoshopProductDetailsVisible';
  var currentColumns = null;
  var detailsVisible = null;
  var resizeTimer = null;

  function isCollectionLikePage() {
    return document.body && (
      document.body.classList.contains('template-collection') ||
      document.body.classList.contains('template-search') ||
      document.querySelector('#main-collection-filters [data-cosmoshop-view-switcher]')
    );
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, String(value));
    } catch (error) {}
  }

  function normaliseColumns(value) {
    value = String(value || '').trim();
    return value === '2' || value === '3' || value === '4' ? value : '4';
  }

  function readStoredState() {
    var storedColumns = storageGet(COLUMN_STORAGE_KEY);
    var storedDetails = storageGet(DETAILS_STORAGE_KEY);

    if (storedColumns || storedDetails) {
      return {
        columns: normaliseColumns(storedColumns || '4'),
        detailsVisible: storedDetails === '' ? true : storedDetails !== '0'
      };
    }

    /* One-time compatibility with the old mutually-exclusive 2/3/4/image setting. */
    var legacy = String(storageGet(LEGACY_STORAGE_KEY) || '').trim().toLowerCase();
    if (legacy === '2' || legacy === '3' || legacy === '4') {
      return { columns: legacy, detailsVisible: true };
    }
    if (legacy === 'image' || legacy === 'image-only' || legacy === 'images') {
      return { columns: '4', detailsVisible: false };
    }

    return { columns: '4', detailsVisible: true };
  }

  function persistState() {
    storageSet(COLUMN_STORAGE_KEY, normaliseColumns(currentColumns || '4'));
    storageSet(DETAILS_STORAGE_KEY, detailsVisible === false ? '0' : '1');
  }

  function gridWidth() {
    var grid = document.querySelector('#ProductGridContainer #product-grid');
    var collection = document.querySelector('#ProductGridContainer .collection');
    var toolbar = document.querySelector('#main-collection-filters');
    var candidate = grid || collection || toolbar;
    var width = candidate ? candidate.getBoundingClientRect().width : 0;
    return width || window.innerWidth || document.documentElement.clientWidth || 0;
  }

  function maxColumnsForViewport() {
    var width = gridWidth();
    if (width >= 1024) return 4;
    if (width >= 768) return 3;
    return 2;
  }

  function actualColumnsForSelection(columns) {
    var max = maxColumnsForViewport();
    var requested = parseInt(normaliseColumns(columns), 10);
    if (!Number.isFinite(requested)) requested = max;
    return Math.max(2, Math.min(requested, max));
  }

  function productGrid() {
    return document.querySelector('#ProductGridContainer #product-grid');
  }

  function productContainer() {
    return document.getElementById('ProductGridContainer');
  }

  function updateControls(actualColumns) {
    var max = maxColumnsForViewport();

    document.querySelectorAll('[data-cosmoshop-columns-button]').forEach(function (button) {
      var cols = parseInt(button.getAttribute('data-cosmoshop-view-cols') || '', 10);
      var available = Number.isFinite(cols) && cols <= max;
      button.hidden = !available;
      button.style.display = available ? '' : 'none';
      var active = available && cols === actualColumns;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-cosmoshop-details-toggle]').forEach(function (button) {
      var hidden = detailsVisible === false;
      button.classList.toggle('cosmoshop-details-hidden', hidden);
      /* This is a toggle, but intentionally does not use the shared .active black fill. */
      button.classList.remove('active');
      button.setAttribute('aria-pressed', hidden ? 'true' : 'false');
      button.setAttribute('aria-label', hidden ? 'Show product details' : 'Hide product details');
      button.setAttribute('title', hidden ? 'Show product details' : 'Hide product details');
    });
  }

  function applyProductView(options, persist) {
    if (!isCollectionLikePage()) return;

    if (typeof options === 'string') {
      var legacyMode = String(options).trim().toLowerCase();
      if (legacyMode === 'image' || legacyMode === 'image-only' || legacyMode === 'images') {
        detailsVisible = false;
      } else {
        currentColumns = normaliseColumns(legacyMode);
        detailsVisible = true;
      }
    } else if (options && typeof options === 'object') {
      if (options.columns != null) currentColumns = normaliseColumns(options.columns);
      if (typeof options.detailsVisible === 'boolean') detailsVisible = options.detailsVisible;
    }

    if (currentColumns == null || detailsVisible == null) {
      var stored = readStoredState();
      if (currentColumns == null) currentColumns = stored.columns;
      if (detailsVisible == null) detailsVisible = stored.detailsVisible;
    }

    currentColumns = normaliseColumns(currentColumns);
    var actualColumns = actualColumnsForSelection(currentColumns);
    var imageOnly = detailsVisible === false;

    if (persist) persistState();

    var grid = productGrid();
    var container = productContainer();

    if (container) {
      container.classList.toggle('cosmoshop-image-only-view', imageOnly);
      container.setAttribute('data-cosmoshop-product-view', String(actualColumns));
      container.setAttribute('data-cosmoshop-product-details', imageOnly ? 'hidden' : 'shown');
    }

    if (grid) {
      grid.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop', 'grid--5-col-desktop');
      grid.classList.add('grid--' + actualColumns + '-col-desktop');
      grid.setAttribute('data-cosmoshop-current-columns', String(actualColumns));
      grid.setAttribute('data-cosmoshop-product-details', imageOnly ? 'hidden' : 'shown');
    }

    document.querySelectorAll('#ProductGridContainer #product-grid > .grid__item').forEach(function (item) {
      item.classList.remove('list-group-item', 'grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop', 'grid--5-col-desktop');
    });

    updateControls(actualColumns);
    if (typeof window.cosmoshopSyncProductPaginationWidth === 'function') {
      window.requestAnimationFrame(window.cosmoshopSyncProductPaginationWidth);
    }
  }

  function refreshSmartButtons() {
    applyProductView(null, false);
  }

  document.addEventListener('click', function (event) {
    var columnsButton = event.target.closest('[data-cosmoshop-columns-button]');
    if (columnsButton) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      applyProductView({ columns: columnsButton.getAttribute('data-cosmoshop-view-cols') }, true);
      return;
    }

    var detailsButton = event.target.closest('[data-cosmoshop-details-toggle]');
    if (!detailsButton) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    if (detailsVisible == null) {
      var stored = readStoredState();
      currentColumns = currentColumns || stored.columns;
      detailsVisible = stored.detailsVisible;
    }
    applyProductView({ detailsVisible: !detailsVisible }, true);
  }, true);

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refreshSmartButtons, 100);
  });

  document.addEventListener('DOMContentLoaded', refreshSmartButtons);
  window.addEventListener('pageshow', refreshSmartButtons);
  document.addEventListener('shopify:section:load', refreshSmartButtons);

  window.cosmoshopApplyProductView = refreshSmartButtons;
  window.cosmoshopSetProductView = applyProductView;
  window.cosmoshopSetProductColumns = function (columns) {
    applyProductView({ columns: columns }, true);
  };
  window.cosmoshopToggleProductDetails = function () {
    if (detailsVisible == null) refreshSmartButtons();
    applyProductView({ detailsVisible: !detailsVisible }, true);
  };
})();

/* Cosmoshop full-width collection/search page-index strip. */
(function () {
  var wheelResetTimer = null;
  var resizeTimer = null;

  function collectionPaginationWrappers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wrappers = [];
    if (root && root.matches && root.matches('#ProductGridContainer .pagination-wrapper')) wrappers.push(root);
    scope.querySelectorAll('#ProductGridContainer .pagination-wrapper').forEach(function (wrapper) {
      if (wrappers.indexOf(wrapper) === -1) wrappers.push(wrapper);
    });
    return wrappers;
  }

  function urlForPage(page) {
    var url = new URL(window.location.href);
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    url.searchParams.set('page', String(page));
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
  }

  function readCurrentPage(wrapper) {
    var explicit = parseInt(wrapper.getAttribute('data-cosmoshop-pagination-current') || '', 10);
    if (Number.isFinite(explicit) && explicit > 0) return explicit;
    var current = wrapper.querySelector('.pagination__item--current');
    var parsed = current ? parseInt(String(current.textContent || '').trim(), 10) : NaN;
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
    var fromUrl = parseInt(new URLSearchParams(window.location.search || '').get('page') || '1', 10);
    return Number.isFinite(fromUrl) && fromUrl > 0 ? fromUrl : 1;
  }

  function readTotalPages(wrapper) {
    var explicit = parseInt(wrapper.getAttribute('data-cosmoshop-pagination-pages') || '', 10);
    if (Number.isFinite(explicit) && explicit > 0) return explicit;
    var container = document.getElementById('ProductGridContainer');
    if (!container) return 1;
    var total = parseInt(container.getAttribute('data-total-results') || '0', 10);
    var perPage = parseInt(container.getAttribute('data-products-per-page') || '0', 10);
    if (!Number.isFinite(total) || !Number.isFinite(perPage) || perPage <= 0) return 1;
    return Math.max(1, Math.ceil(total / perPage));
  }

  function rebuildAllPages(wrapper) {
    var list = wrapper.querySelector('.pagination__list');
    if (!list || wrapper.hasAttribute('data-cosmoshop-all-pages-ready')) return;
    var totalPages = readTotalPages(wrapper);
    var currentPage = Math.min(Math.max(readCurrentPage(wrapper), 1), totalPages);
    if (totalPages <= 1) return;

    var html = '';
    for (var page = 1; page <= totalPages; page += 1) {
      if (page === currentPage) {
        html += '<li><a href="' + urlForPage(page) + '" class="pagination__item pagination__item--current link" data-cosmoshop-client-page="' + page + '" aria-current="page" aria-label="Page ' + page + '">' + page + '</a></li>';
      } else {
        html += '<li><a href="' + urlForPage(page) + '" class="pagination__item link" data-cosmoshop-client-page="' + page + '" aria-label="Page ' + page + '">' + page + '</a></li>';
      }
    }
    list.innerHTML = html;
    wrapper.setAttribute('data-cosmoshop-pagination-pages', String(totalPages));
    wrapper.setAttribute('data-cosmoshop-pagination-current', String(currentPage));
    wrapper.setAttribute('data-cosmoshop-all-pages-ready', '');
  }

  function paginationNaturalWidth(wrapper) {
    var list = wrapper.querySelector('.pagination__list');
    if (!list) return 0;
    var items = Array.prototype.slice.call(list.children || []);
    if (!items.length) return 0;

    var style = window.getComputedStyle(list);
    var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    var paddingLeft = parseFloat(style.paddingLeft || '0') || 0;
    var paddingRight = parseFloat(style.paddingRight || '0') || 0;
    var width = paddingLeft + paddingRight + (gap * Math.max(0, items.length - 1));

    items.forEach(function (item) {
      var rect = item.getBoundingClientRect();
      var itemStyle = window.getComputedStyle(item);
      width += rect.width;
      width += parseFloat(itemStyle.marginLeft || '0') || 0;
      width += parseFloat(itemStyle.marginRight || '0') || 0;
    });

    return Math.ceil(width);
  }

  function syncWidth(wrapper) {
    var grid = document.querySelector('#ProductGridContainer #product-grid');
    var products = wrapper.closest('#products') || wrapper.parentElement;
    if (!grid || !products) return;
    var gridRect = grid.getBoundingClientRect();
    var productsRect = products.getBoundingClientRect();
    if (!gridRect.width || !productsRect.width) return;

    var availableWidth = Math.min(gridRect.width, productsRect.width);
    var maximumWidth = availableWidth * 0.70;
    var contentWidth = paginationNaturalWidth(wrapper);
    var targetWidth = contentWidth > 0 ? Math.min(maximumWidth, contentWidth) : maximumWidth;
    var gridLeftInsideProducts = gridRect.left - productsRect.left;
    var centredOffset = gridLeftInsideProducts + ((gridRect.width - targetWidth) / 2);

    wrapper.style.width = Math.max(0, targetWidth) + 'px';
    wrapper.style.maxWidth = maximumWidth + 'px';
    wrapper.style.marginLeft = Math.max(0, centredOffset) + 'px';
  }

  function ensureProgress(wrapper) {
    var pagination = wrapper.querySelector('.pagination');
    if (!pagination) return null;
    var progress = wrapper.querySelector('.cosmoshop-pagination-progress');
    if (!progress) {
      progress = document.createElement('div');
      progress.className = 'cosmoshop-pagination-progress';
      progress.setAttribute('aria-hidden', 'true');
      progress.innerHTML = '<span class="cosmoshop-pagination-progress__thumb"></span>';
      pagination.appendChild(progress);
    }
    return progress;
  }

  function syncProgress(wrapper) {
    var list = wrapper.querySelector('.pagination__list');
    var progress = ensureProgress(wrapper);
    if (!list || !progress) return;
    var thumb = progress.querySelector('.cosmoshop-pagination-progress__thumb');
    if (!thumb) return;

    var scrollable = Math.max(0, list.scrollWidth - list.clientWidth);

    // If every pagination button fits, there is nothing to scroll, so hide
    // the custom position slider completely instead of showing a full-width
    // black thumb underneath the page numbers.
    if (scrollable <= 1) {
      progress.classList.remove('is-visible');
      thumb.style.width = '';
      thumb.style.transform = 'translateX(0px)';
      return;
    }

    progress.classList.add('is-visible');
    var trackWidth = progress.clientWidth || 110;
    var visibleRatio = Math.min(1, list.clientWidth / list.scrollWidth);
    var thumbWidth = Math.max(20, Math.round(trackWidth * visibleRatio));
    var travel = Math.max(0, trackWidth - thumbWidth);
    var progressRatio = Math.max(0, Math.min(1, list.scrollLeft / scrollable));
    thumb.style.width = thumbWidth + 'px';
    thumb.style.transform = 'translateX(' + Math.round(travel * progressRatio) + 'px)';
  }

  function bindProgressDrag(wrapper) {
    var list = wrapper.querySelector('.pagination__list');
    var progress = ensureProgress(wrapper);
    if (!list || !progress || progress.dataset.cosmoshopDragReady === 'true') return;

    var thumb = progress.querySelector('.cosmoshop-pagination-progress__thumb');
    if (!thumb) return;

    progress.dataset.cosmoshopDragReady = 'true';
    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var dragScale = 0;

    thumb.addEventListener('pointerdown', function (event) {
      if (event.button !== undefined && event.button !== 0) return;

      var scrollable = Math.max(0, list.scrollWidth - list.clientWidth);
      var trackWidth = progress.clientWidth;
      var thumbWidth = thumb.getBoundingClientRect().width;
      var thumbTravel = Math.max(0, trackWidth - thumbWidth);
      if (scrollable <= 0 || thumbTravel <= 0) return;

      event.preventDefault();
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = list.scrollLeft;
      dragScale = scrollable / thumbTravel;
      progress.classList.add('is-dragging');

      if (thumb.setPointerCapture) thumb.setPointerCapture(event.pointerId);
    });

    thumb.addEventListener('pointermove', function (event) {
      if (pointerId === null || event.pointerId !== pointerId) return;

      event.preventDefault();
      var scrollable = Math.max(0, list.scrollWidth - list.clientWidth);
      var deltaX = event.clientX - startX;
      list.scrollLeft = Math.max(0, Math.min(scrollable, startScrollLeft + (deltaX * dragScale)));
      syncProgress(wrapper);
    });

    function finishDrag(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var releasedPointerId = pointerId;
      pointerId = null;
      progress.classList.remove('is-dragging');

      if (thumb.hasPointerCapture && thumb.hasPointerCapture(releasedPointerId)) {
        thumb.releasePointerCapture(releasedPointerId);
      }
    }

    thumb.addEventListener('pointerup', finishDrag);
    thumb.addEventListener('pointercancel', finishDrag);
  }

  function centerCurrent(wrapper, instant) {
    var list = wrapper.querySelector('.pagination__list');
    var current = wrapper.querySelector('.pagination__item--current');
    if (!list || !current) return;
    var left = current.offsetLeft - ((list.clientWidth - current.offsetWidth) / 2);
    var max = Math.max(0, list.scrollWidth - list.clientWidth);
    var target = Math.max(0, Math.min(left, max));
    if (instant) {
      list.scrollLeft = target;
      syncProgress(wrapper);
    } else {
      list.scrollTo({ left: target, behavior: 'smooth' });
    }
  }

  function bindWheel(wrapper) {
    var list = wrapper.querySelector('.pagination__list');
    if (!list || list.dataset.cosmoshopWheelReady === 'true') return;
    list.dataset.cosmoshopWheelReady = 'true';

    list.addEventListener('scroll', function () {
      syncProgress(wrapper);
    }, { passive: true });

    list.addEventListener('wheel', function (event) {
      if (list.scrollWidth <= list.clientWidth + 1) return;
      var delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (!delta) return;
      var atStart = list.scrollLeft <= 0;
      var atEnd = list.scrollLeft >= list.scrollWidth - list.clientWidth - 1;
      if ((delta < 0 && atStart) || (delta > 0 && atEnd)) return;
      event.preventDefault();
      list.scrollLeft += delta * 2;
      syncProgress(wrapper);
      window.clearTimeout(wheelResetTimer);
      wheelResetTimer = window.setTimeout(function () {}, 40);
    }, { passive: false });
  }

  function enhance(wrapper) {
    if (!wrapper) return;
    rebuildAllPages(wrapper);
    syncWidth(wrapper);
    ensureProgress(wrapper);
    bindWheel(wrapper);
    bindProgressDrag(wrapper);
    window.requestAnimationFrame(function () {
      centerCurrent(wrapper, true);
      syncProgress(wrapper);
    });
  }

  function enhanceAll() {
    collectionPaginationWrappers(document).forEach(enhance);
  }

  window.cosmoshopEnhanceProductPagination = enhance;
  window.cosmoshopSyncProductPaginationWidth = function () {
    collectionPaginationWrappers(document).forEach(syncWidth);
  };

  document.addEventListener('DOMContentLoaded', enhanceAll);
  window.addEventListener('pageshow', enhanceAll);
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(enhanceAll, 0);
  });
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      collectionPaginationWrappers(document).forEach(function (wrapper) {
        syncWidth(wrapper);
        centerCurrent(wrapper, true);
        syncProgress(wrapper);
      });
    }, 100);
  });

  // Filter/AJAX renders replace the pagination node. Re-enhance only when a new
  // pagination wrapper is inserted, avoiding any polling or repeated layout work.
  var paginationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;
        if (node.matches && node.matches('#ProductGridContainer .pagination-wrapper')) enhance(node);
        if (node.querySelectorAll) node.querySelectorAll('#ProductGridContainer .pagination-wrapper').forEach(enhance);
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('ProductGridContainer');
    if (container) paginationObserver.observe(container, { childList: true, subtree: true });
  });
})();
